// eslint-disable-next-line no-unused-vars
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = (
  iconColor: string | undefined,
  background: string | undefined,
  circlePadding: number | undefined,
) =>
  makeStyles((theme: Theme) =>
    createStyles({
      root: {
        '& > *': {
          fill: iconColor,
        },
      },
      circle: {
        background,
        padding: circlePadding,
        borderRadius: '50%',
        overflow: 'visible',
        boxSizing: 'content-box',
      },
    }),
  );

export default useStyles;
